const button = document.getElementById('hamburger');
const navbar = document.getElementById('header-main-menu');

function toggleNav() {
  const isHidden = button.getAttribute('aria-expanded') === 'false';
  button.setAttribute('aria-expanded', isHidden);
  navbar.setAttribute('aria-hidden', !isHidden);
  document.documentElement.classList.toggle('is-open');
}

function init() {
  button.addEventListener('click', toggleNav);
}

export default {
  init,
};
